<template>
    <div class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem modal-agendar" @click.stop>
            <div class="modal-header">
                <h3>Agendar reunião</h3>
            </div>
            <div class="modal-corpo">
                <div class="grid-3">
                    <fieldset class="col-3 tipo-reuniao">
                        <legend>Tipo de reunião</legend>
                        <label class="opcao-tipo">
                            <input
                                v-model="tipoReuniao"
                                type="radio"
                                value="weekly"
                                name="tipo-reuniao-projeto"
                                @change="aplicarPadraoTipo"> Weekly </label>
                        <label class="opcao-tipo">
                            <input
                                v-model="tipoReuniao"
                                type="radio"
                                value="outros"
                                name="tipo-reuniao-projeto"
                                @change="aplicarPadraoTipo"> Outros </label>
                    </fieldset>
                    <div class="col-3">
                        <label>Assunto *</label>
                        <input v-model="form.summary" type="text" placeholder="Título da reunião" maxlength="255">
                    </div>
                    <div>
                        <label>Data *</label>
                        <input v-model="form.data" type="date" @change="onDataAlterada">
                    </div>
                    <div>
                        <label>Início *</label>
                        <input v-model="form.hora_inicio" type="time">
                    </div>
                    <div>
                        <label>Duração *</label>
                        <input v-model="form.duracao" type="time" step="60" title="Duração (hh:mm)">
                    </div>
                    <fieldset class="col-3 tipo-reuniao">
                        <legend>Onde</legend>
                        <label class="opcao-tipo">
                            <input v-model="modalidade" type="radio" value="online" name="modalidade-reuniao">
                            Online
                        </label>
                        <label class="opcao-tipo">
                            <input v-model="modalidade" type="radio" value="sala" name="modalidade-reuniao">
                            Sala de reunião
                        </label>
                    </fieldset>
                    <div v-if="modalidade === 'sala'" class="col-3">
                        <label>Sala *</label>
                        <select v-model="salaId" :disabled="carregandoSalas || salas.length === 0">
                            <option :value="null" hidden>Selecione a sala</option>
                            <option v-for="sala in salas" :key="sala.id" :value="sala.id">
                                {{ sala.nome }}<template v-if="sala.capacidade"> — {{ sala.capacidade }} lugares</template>
                            </option>
                        </select>
                        <p v-if="carregandoSalas" class="fonte-fraca fonte-menor">Carregando salas…</p>
                        <p v-else-if="salas.length === 0" class="fonte-fraca fonte-menor">Nenhuma sala ativa cadastrada.</p>
                    </div>
                    <p v-else class="col-3 fonte-fraca fonte-menor">A reunião ganha um link do Google Meet.</p>
                    <div v-if="tipoReuniao === 'weekly'" class="col-3">
                        <label>Pacotes de trabalho da semana</label>
                        <p class="fonte-fraca fonte-menor">
                            Pacotes ativos do projeto. Concluídos só entram se ainda não passaram por uma weekly.
                        </p>
                        <p v-if="carregandoPacotes" class="fonte-fraca fonte-menor">Carregando pacotes…</p>
                        <p v-else-if="pacotesWeekly.length === 0" class="fonte-fraca fonte-menor">
                            Nenhum pacote de trabalho elegível neste projeto.
                        </p>
                        <div v-else class="lista-tarefas-weekly">
                            <label v-for="pacote in pacotesWeekly" :key="pacote.id" class="item-tarefa-weekly">
                                <input type="checkbox" :value="pacote.id" v-model="pacoteIdsSelecionados">
                                <span class="item-tarefa-weekly__corpo">
                                    <span class="item-tarefa-weekly__titulo">
                                        {{ pacote.nome || 'Sem nome' }}
                                    </span>
                                    <span class="item-tarefa-weekly__meta">
                                        <span class="chip" :class="classeSituacao(pacote.situacao)">
                                            {{ labelSituacao(pacote.situacao) }}
                                        </span>
                                        Fim previsto: {{ formatarDataBr(pacote.dtFim) }}
                                        · {{ pacote.status || '—' }}
                                        · {{ pacote.responsavel?.name || 'Sem responsável' }}
                                    </span>
                                </span>
                            </label>
                        </div>
                        <div v-if="convidadosWeekly.length" class="chips-convidados">
                            <span class="fonte-fraca fonte-menor" style="width: 100%; margin: 0;">
                                Convidados (responsáveis dos pacotes selecionados):
                            </span>
                            <span v-for="u in convidadosWeekly" :key="u.id" class="chip-convidado">
                                {{ u.name }}
                            </span>
                        </div>
                    </div>
                    <div v-else class="col-3">
                        <label>Convidados</label>
                        <AutoCompleteComponent :BaseOpcoes="opcoesDisponiveis"
                            prop-placeholder="Buscar envolvido no projeto…" prop-style="width: 100%"
                            @adicionar="adicionarConvidado" />
                        <div v-if="convidados.length" class="chips-convidados">
                            <span v-for="u in convidados" :key="u.id" class="chip-convidado"> {{ u.nomeCompleto || u.name }} <button type="button" class="chip-remover" aria-label="Remover"
                                    @click="removerConvidado(u.id)">
                                    <i class="bi bi-x"></i>
                                </button>
                            </span>
                        </div>
                        <p v-if="!carregandoEnvolvidos && envolvidos.length === 0" class="fonte-fraca fonte-menor"> Nenhum envolvido com e-mail encontrado neste projeto. </p>
                        <p v-if="carregandoEnvolvidos" class="fonte-fraca fonte-menor">Carregando envolvidos…</p>
                    </div>
                    <div class="col-3">
                        <label>Descrição</label>
                        <textarea v-model="form.description" rows="3" placeholder="Pauta ou observações"></textarea>
                    </div>
                    <div v-if="mostrarDisponibilidade" class="col-3 disponibilidade">
                        <label>Disponibilidade neste horário</label>
                        <p v-if="consultandoDisponibilidade" class="fonte-fraca fonte-menor">Consultando agendas…</p>
                        <p v-else-if="erroDisponibilidade" class="fonte-fraca fonte-menor">
                            {{ erroDisponibilidade }}
                            <button
                                v-if="precisaReconectarGoogle"
                                type="button"
                                class="acao-secundaria"
                                @click="$emit('conectar-google')">
                                Atualizar permissão do Google
                            </button>
                        </p>
                        <ul v-else class="lista-disponibilidade">
                            <li v-if="modalidade === 'sala' && salaSelecionada">
                                <span>{{ salaSelecionada.nome }}</span>
                                <span class="chip" :class="classeDisponibilidade(disponibilidade.sala?.status)">
                                    {{ textoDisponibilidade(disponibilidade.sala) }}
                                </span>
                            </li>
                            <li v-for="pessoa in pessoasDisponibilidade" :key="pessoa.chave">
                                <span>{{ pessoa.nome }}</span>
                                <span class="chip" :class="classeDisponibilidade(pessoa.status)">
                                    {{ textoDisponibilidade(pessoa) }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <p v-if="erroExibido" class="erro-local" role="alert">{{ erroExibido }}</p>
            </div>
            <div class="modal-footer">
                <div class="submit">
                    <button :disabled="salvando || !podeSalvar" @click="confirmar"> {{ salvando ? 'Agendando…' : 'Agendar' }} </button>
                    <button class="acao-secundaria" :disabled="salvando" @click="$emit('fechar')">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AutoCompleteComponent from '@/components/AutoComplete/AutoCompleteComponent.vue'
import serviceReunioesProjeto from '@/services/serviceReunioesProjeto'
import { formatarDataBr } from '@/utils/date'

const SITUACOES_TAREFA = {
    atrasada: { label: 'Atrasada', chip: 'bg-erro' },
    concluida_com_atraso: { label: 'Concluída com atraso', chip: 'bg-alerta' },
    concluida: { label: 'Concluída no prazo', chip: 'bg-sucesso' },
    semana: { label: 'Semana', chip: 'bg-cinza' },
    sem_prazo: { label: 'Sem prazo', chip: 'bg-cinza' },
}

export default {
    name: 'ModalAgendarReuniaoProjeto',
    components: { AutoCompleteComponent },
    props: {
        projetoId: { type: [Number, String], required: true },
        projetoNome: { type: String, default: '' },
        projetoCodigo: { type: String, default: '' },
        salvando: { type: Boolean, default: false },
        erroExterno: { type: String, default: null },
    },
    emits: ['fechar', 'confirmar', 'conectar-google'],
    data() {
        const hoje = new Date()
        const y = hoje.getFullYear()
        const m = String(hoje.getMonth() + 1).padStart(2, '0')
        const d = String(hoje.getDate()).padStart(2, '0')
        return {
            tipoReuniao: 'weekly',
            modalidade: 'online',
            salaId: null,
            salas: [],
            carregandoSalas: false,
            disponibilidade: { sala: null, convidados: [] },
            consultandoDisponibilidade: false,
            erroDisponibilidade: null,
            precisaReconectarGoogle: false,
            consultaSeq: 0,
            timerDisponibilidade: null,
            form: {
                summary: this.montarTituloPadrao('weekly'),
                data: `${y}-${m}-${d}`,
                hora_inicio: '09:00',
                duracao: '00:15',
                description: this.pautaWeekly(),
            },
            envolvidos: [],
            convidados: [],
            pacotesWeekly: [],
            pacoteIdsSelecionados: [],
            carregandoEnvolvidos: false,
            carregandoPacotes: false,
            erroLocal: null,
        }
    },
    computed: {
        podeSalvar() {
            return Boolean(
                this.form.summary?.trim()
                && this.form.data
                && this.form.hora_inicio
                && this.form.duracao
                && this.minutosDuracao > 0
                && (this.modalidade === 'online' || (this.modalidade === 'sala' && this.salaId))
            )
        },
        minutosDuracao() {
            const [h, m] = String(this.form.duracao || '00:00').split(':').map(Number)
            if (Number.isNaN(h) || Number.isNaN(m)) return 0
            return (h * 60) + m
        },
        opcoesDisponiveis() {
            const idsSelecionados = new Set(this.convidados.map((u) => u.id))
            return this.envolvidos.filter((u) => !idsSelecionados.has(u.id))
        },
        convidadosWeekly() {
            const porId = new Map()
            this.pacotesWeekly
                .filter((pacote) => this.pacoteIdsSelecionados.includes(pacote.id))
                .forEach((pacote) => {
                    if (!pacote.responsavel?.id) return
                    porId.set(pacote.responsavel.id, pacote.responsavel)
                })
            return [...porId.values()]
        },
        erroExibido() {
            return this.erroExterno || this.erroLocal
        },
        salaSelecionada() {
            return this.salas.find((sala) => String(sala.id) === String(this.salaId)) || null
        },
        pessoasConsulta() {
            const pessoas = this.tipoReuniao === 'weekly' ? this.convidadosWeekly : this.convidados
            const porEmail = new Map()
            pessoas.forEach((pessoa) => {
                const email = String(pessoa.email || '').trim().toLowerCase()
                const chave = email || `sem-email-${pessoa.id}`
                if (porEmail.has(chave)) return
                porEmail.set(chave, {
                    chave,
                    id: pessoa.id,
                    nome: pessoa.nomeCompleto || pessoa.name || email || 'Convidado',
                    email,
                })
            })
            return [...porEmail.values()]
        },
        mostrarDisponibilidade() {
            return (this.modalidade === 'sala' && this.salaId) || this.pessoasConsulta.length > 0
        },
        pessoasDisponibilidade() {
            const porEmail = new Map(
                (this.disponibilidade.convidados || []).map((pessoa) => [String(pessoa.email || '').toLowerCase(), pessoa])
            )
            return this.pessoasConsulta.map((pessoa) => {
                if (!pessoa.email) {
                    return { ...pessoa, status: 'sem_email', intervalos: [] }
                }
                const encontrada = porEmail.get(pessoa.email)
                return {
                    ...pessoa,
                    nome: pessoa.nome || encontrada?.nome || pessoa.email,
                    status: encontrada?.status || null,
                    intervalos: encontrada?.intervalos || [],
                }
            })
        },
    },
    watch: {
        'form.data': 'agendarConsultaDisponibilidade',
        'form.hora_inicio': 'agendarConsultaDisponibilidade',
        'form.duracao': 'agendarConsultaDisponibilidade',
        modalidade: 'agendarConsultaDisponibilidade',
        salaId: 'agendarConsultaDisponibilidade',
        pessoasConsulta: 'agendarConsultaDisponibilidade',
    },
    async mounted() {
        await this.carregarSalas()
        if (this.tipoReuniao === 'weekly') {
            await this.carregarPacotesWeekly()
        } else {
            await this.carregarEnvolvidos()
        }
        this.agendarConsultaDisponibilidade()
    },
    beforeUnmount() {
        clearTimeout(this.timerDisponibilidade)
    },
    methods: {
        formatarDataBr,
        labelSituacao(situacao) {
            return SITUACOES_TAREFA[situacao]?.label || 'Semana'
        },
        classeSituacao(situacao) {
            return SITUACOES_TAREFA[situacao]?.chip || 'bg-cinza'
        },
        classeDisponibilidade(status) {
            if (status === 'livre') return 'bg-sucesso'
            if (status === 'ocupado') return 'bg-erro'
            return 'bg-cinza'
        },
        textoDisponibilidade(item) {
            if (!item?.status) return 'Consultando…'
            if (item.status === 'livre') return 'Livre'
            if (item.status === 'sem_email') return 'Sem e-mail'
            if (item.status === 'ocupado') {
                const faixas = (item.intervalos || []).map((faixa) => `${faixa.inicio}–${faixa.fim}`)
                return faixas.length ? `Ocupado ${faixas.join(', ')}` : 'Ocupado neste horário'
            }
            return 'Agenda não compartilhada'
        },
        agendarConsultaDisponibilidade() {
            clearTimeout(this.timerDisponibilidade)
            this.timerDisponibilidade = setTimeout(() => this.consultarDisponibilidade(), 400)
        },
        async consultarDisponibilidade() {
            const emails = this.pessoasConsulta.map((pessoa) => pessoa.email).filter(Boolean)
            const salaId = this.modalidade === 'sala' && this.salaId ? Number(this.salaId) : null
            if ((!salaId && emails.length === 0) || !this.form.data || !this.form.hora_inicio || this.minutosDuracao <= 0) {
                this.disponibilidade = { sala: null, convidados: [] }
                this.erroDisponibilidade = null
                this.consultandoDisponibilidade = false
                return
            }

            const seq = ++this.consultaSeq
            this.consultandoDisponibilidade = true
            this.erroDisponibilidade = null
            this.precisaReconectarGoogle = false
            const horaInicio = this.form.hora_inicio.slice(0, 5)
            try {
                const data = await serviceReunioesProjeto.disponibilidade(this.projetoId, {
                    data: this.form.data,
                    hora_inicio: horaInicio,
                    hora_fim: this.calcularHoraFim(horaInicio, this.minutosDuracao),
                    sala_id: salaId,
                    emails,
                })
                if (seq !== this.consultaSeq) return
                this.disponibilidade = {
                    sala: data?.sala || null,
                    convidados: data?.convidados || [],
                }
            } catch (e) {
                if (seq !== this.consultaSeq) return
                const code = e.response?.data?.code
                this.disponibilidade = { sala: null, convidados: [] }
                this.precisaReconectarGoogle = e.response?.status === 403
                    && ['google_not_connected', 'google_reauthorization_required'].includes(code)
                this.erroDisponibilidade = e.response?.data?.message
                    || 'Não foi possível consultar a disponibilidade.'
            } finally {
                if (seq === this.consultaSeq) this.consultandoDisponibilidade = false
            }
        },
        montarTituloPadrao(tipo = this.tipoReuniao) {
            const codigo = String(this.projetoCodigo || '').trim()
            const nome = String(this.projetoNome || '').trim()
            const prefixo = tipo === 'weekly' ? 'weekly' : 'Reunião'
            if (codigo && nome) return `${prefixo} - ${codigo} - ${nome}`
            if (codigo) return `${prefixo} - ${codigo}`
            if (nome) return `${prefixo} - ${nome}`
            return ''
        },
        pautaWeekly() {
            return [
                '1. O que você concluiu esta semana?',
                '2. O que está em andamento?',
                '3. Tem algum bloqueio?',
            ].join('\n')
        },
        aplicarPadraoTipo() {
            this.form.summary = this.montarTituloPadrao()
            this.form.description = this.tipoReuniao === 'weekly' ? this.pautaWeekly() : ''
            this.erroLocal = null
            if (this.tipoReuniao === 'weekly') {
                this.carregarPacotesWeekly()
            } else if (!this.envolvidos.length) {
                this.carregarEnvolvidos()
            }
        },
        onDataAlterada() {
            if (this.tipoReuniao === 'weekly') {
                this.carregarPacotesWeekly()
            }
        },
        async carregarSalas() {
            if (!this.projetoId) return
            this.carregandoSalas = true
            try {
                this.salas = await serviceReunioesProjeto.listarSalas(this.projetoId)
            } catch (_) {
                this.salas = []
            } finally {
                this.carregandoSalas = false
            }
        },
        async carregarEnvolvidos() {
            if (!this.projetoId) return
            this.carregandoEnvolvidos = true
            try {
                this.envolvidos = await serviceReunioesProjeto.listarEnvolvidos(this.projetoId)
            } catch (_) {
                this.envolvidos = []
            } finally {
                this.carregandoEnvolvidos = false
            }
        },
        async carregarPacotesWeekly() {
            if (!this.projetoId || !this.form.data) return
            this.carregandoPacotes = true
            try {
                this.pacotesWeekly = await serviceReunioesProjeto.listarPacotesWeekly(this.projetoId, this.form.data)
                const idsValidos = new Set(this.pacotesWeekly.map((pacote) => pacote.id))
                this.pacoteIdsSelecionados = this.pacoteIdsSelecionados.filter((id) => idsValidos.has(id))
            } catch (_) {
                this.pacotesWeekly = []
                this.pacoteIdsSelecionados = []
            } finally {
                this.carregandoPacotes = false
            }
        },
        adicionarConvidado(usuario) {
            if (!usuario?.id || !usuario?.email) return
            if (this.convidados.some((u) => u.id === usuario.id)) return
            this.convidados.push({
                id: usuario.id,
                name: usuario.name || usuario.nomeCompleto,
                nomeCompleto: usuario.nomeCompleto || usuario.name,
                email: usuario.email,
            })
        },
        removerConvidado(id) {
            this.convidados = this.convidados.filter((u) => u.id !== id)
        },
        calcularHoraFim(horaInicio, duracaoMinutos) {
            const [h, m] = String(horaInicio).slice(0, 5).split(':').map(Number)
            const total = (h * 60) + m + duracaoMinutos
            const fimH = Math.floor(total / 60) % 24
            const fimM = total % 60
            return `${String(fimH).padStart(2, '0')}:${String(fimM).padStart(2, '0')}`
        },
        confirmar() {
            this.erroLocal = null
            if (!this.podeSalvar) {
                this.erroLocal = 'Preencha assunto, data, início e duração.'
                return
            }
            if (this.minutosDuracao <= 0) {
                this.erroLocal = 'A duração deve ser maior que zero.'
                return
            }
            if (this.modalidade === 'sala' && !this.salaId) {
                this.erroLocal = 'Selecione a sala de reunião.'
                return
            }
            const horaInicio = this.form.hora_inicio.slice(0, 5)
            const payload = {
                tipo: this.tipoReuniao,
                modalidade: this.modalidade,
                sala_id: this.modalidade === 'sala' ? Number(this.salaId) : null,
                summary: this.form.summary.trim(),
                data: this.form.data,
                hora_inicio: horaInicio,
                hora_fim: this.calcularHoraFim(horaInicio, this.minutosDuracao),
                description: this.form.description?.trim() || null,
            }
            if (this.tipoReuniao === 'weekly') {
                payload.entrega_ids = [...this.pacoteIdsSelecionados]
            } else {
                payload.emails_convidados = this.convidados
                    .map((u) => String(u.email || '').trim().toLowerCase())
                    .filter(Boolean)
            }
            this.$emit('confirmar', payload)
        },
    },
}
</script>
<style scoped>
.modal-agendar {
    min-width: min(36rem, 92vw);
    max-width: 50rem;
    max-height: 90vh;
    overflow: auto;
}

.modal-header h3 {
    margin: 0 0 1rem;
}

.modal-corpo {
    margin-bottom: 1rem;
}

.tipo-reuniao {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 0;
    border: 0;
}

.tipo-reuniao legend {
    margin-bottom: 0.45rem;
    font-weight: 600;
}

.opcao-tipo {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    margin: 0;
    cursor: pointer;
}

.opcao-tipo input {
    width: auto;
    margin: 0;
}

.modal-agendar select {
    width: 100%;
}

.chips-convidados {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-top: 0.6rem;
}

.chip-convidado {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.2rem 0.45rem;
    border-radius: 999px;
    background: var(--cor-primaria-fraca, #e8eef7);
    font-size: 0.85rem;
}

.chip-remover {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    color: inherit;
    line-height: 1;
}

.chip-remover:hover {
    color: var(--cor-erro, #b91c1c);
}

.erro-local {
    color: var(--cor-erro, #b91c1c);
    margin-top: 0.75rem;
    font-size: 0.9rem;
}

.lista-disponibilidade {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin: 0.4rem 0 0;
    padding: 0;
    list-style: none;
}

.lista-disponibilidade li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
}

.lista-tarefas-weekly {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    max-height: 16rem;
    overflow: auto;
    margin-top: 0.5rem;
    padding: 0.4rem;
    border: 1px solid var(--cor-separador, #e5e7eb);
    border-radius: 8px;
}

.item-tarefa-weekly {
    display: flex;
    align-items: flex-start;
    gap: 0.55rem;
    margin: 0;
    cursor: pointer;
}

.item-tarefa-weekly input {
    width: auto;
    margin-top: 0.2rem;
}

.item-tarefa-weekly__corpo {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
}

.item-tarefa-weekly__titulo {
    font-weight: 600;
}

.item-tarefa-weekly__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    opacity: 0.85;
}
</style>
